import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class GlobalService {
    islogged = false;
    loginUserName = '';
    userTypeID = '';
    isHeaderShow = true;

    public islogged$ = new BehaviorSubject<boolean>(this.islogged);
    public loginName$ = new BehaviorSubject<String>(this.loginUserName);
    public userTypeID$ = new BehaviorSubject<string>(this.userTypeID);

    // RP : 25 Aug 2020 - Very Important | Read before making any changes
    // Do not change below value for any purpose. Deployment will happen automatically
    // http://localhost:55490/" is a keyword for deployment
  public readonly BaseUrl: string = 'http://localhost:55490/';
    // https://devapi.centumlearnpro.in/'

  //  public readonly BaseUrl: string = 'https://api.centumlearnpro.in/';
    // public readonly BaseUrl: string = 'https://ttkapi.centumlearnpro.in/';
  //   public readonly BaseUrl: string = 'https://demoapi.centumlearnpro.in/';
 //  public readonly BaseUrl: string = 'https://atomapiv2.centumlearnpro.in/';
   public readonly SimulationShow = true;

    public readonly hideHeader = ['/login', '/force-login', '/forgot-password', 'change-password', '/simulations-details', '/test']; // '/test',
    public readonly hideFooter = ['/login', '/force-login', '/forgot-password', 'change-password'];
    public readonly hideSidebar = ['/report-pdf', '/assessment-report-pdf'];

    constructor() { }
    onGetMonthInString(num): string {
        let monthName = '';
        switch (num) {
            case 1:
                monthName = 'Jan';
                break;
            case 2:
                monthName = 'Feb';
                break;
            case 3:
                monthName = 'Mar';
                break;
            case 4:
                monthName = 'Apr';
                break;
            case 5:
                monthName = 'May';
                break;
            case 6:
                monthName = 'Jun';
                break;
            case 7:
                monthName = 'Jul';
                break;
            case 8:
                monthName = 'Aug';
                break;
            case 9:
                monthName = 'Sep';
                break;
            case 10:
                monthName = 'Oct';
                break;
            case 11:
                monthName = 'Nov';
                break;
            case 12:
                monthName = 'Dec';
                break;

            default:
                break;
        }
        return monthName;

    }
}
